import React from 'react';
import {Col, Row, Upload} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import InputFormField from '../../components/data_entry/form/InputFormField';
import SelectFormField from '../../components/data_entry/form/SelectFormField';
import DatePickerFormField from '../../components/data_entry/form/DatePickerFormField';
import TextAreaFormField from '../../components/data_entry/form/TextAreaFormField';
import Button from '../../components/data_entry/Button';
import Form from '../../components/data_entry/form/Form';
import {CLIENT_TYPE} from '../../constants/constants';
import {FIELD_NAMES, GENDER_OPTIONS} from './constants';

export default function DependentSection({clientType, uploadProps, normFile}) {
    const showFullDependent = clientType === CLIENT_TYPE.PATIENT_TUTOR;
    const showNameOnly = clientType === CLIENT_TYPE.PET_TUTOR;

    return (
        <>
            {!clientType && (
                <p>Selecione o tipo de associado acima para preencher esta seção.</p>
            )}

            {showFullDependent && (
                <Row gutter={16}>
                    <Col xs={24} sm={12} lg={8}>
                        <InputFormField
                            form={{
                                label: 'Nome do Dependente',
                                name: FIELD_NAMES.DEP_FIRST_NAME,
                                rules: [{required: true, message: 'Campo obrigatório'}],
                            }}
                            placeholder="Nome"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                        <InputFormField
                            form={{
                                label: 'Sobrenome do Dependente',
                                name: FIELD_NAMES.DEP_LAST_NAME,
                                rules: [{required: true, message: 'Campo obrigatório'}],
                            }}
                            placeholder="Sobrenome"
                        />
                    </Col>

                    <Col xs={24} sm={12} lg={8}>
                        <InputFormField
                            form={{
                                label: 'CPF do Dependente',
                                name: FIELD_NAMES.DEP_CPF,
                                rules: [{required: true, message: 'Campo obrigatório'}],
                            }}
                            placeholder="000.000.000-00"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                        <InputFormField
                            form={{
                                label: 'RG do Dependente',
                                name: FIELD_NAMES.DEP_RG,
                            }}
                            placeholder="RG"
                        />
                    </Col>

                    <Col xs={24} sm={12} lg={8}>
                        <DatePickerFormField
                            form={{
                                label: 'Data de Nascimento do Dependente',
                                name: FIELD_NAMES.DEP_BIRTH_DATE,
                                rules: [{required: true, message: 'Campo obrigatório'}],
                            }}
                            placeholder="Selecione a data"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                        <SelectFormField
                            form={{
                                label: 'Gênero do Dependente',
                                name: FIELD_NAMES.DEP_GENDER,
                                rules: [{required: true, message: 'Campo obrigatório'}],
                            }}
                            options={GENDER_OPTIONS}
                            placeholder="Selecione"
                        />
                    </Col>
                </Row>
            )}

            {showNameOnly && (
                <InputFormField
                    form={{
                        label: 'Nome do Pet',
                        name: FIELD_NAMES.DEP_FIRST_NAME,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="Nome do pet"
                />
            )}

            {clientType && (
                <>
                    <TextAreaFormField
                        form={{
                            label: 'Condição Médica',
                            name: FIELD_NAMES.DEP_MEDICAL_CONDITION,
                            rules: [{required: true, message: 'Campo obrigatório'}],
                        }}
                        placeholder="Descreva a condição médica"
                        rows={4}
                    />
                    <Form.Item
                        label="Laudo Médico (PDF)"
                        name={FIELD_NAMES.DEP_MEDICAL_REPORT_PDF}
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[{required: true, message: 'Campo obrigatório'}]}
                    >
                        <Upload {...uploadProps}>
                            <Button icon={<UploadOutlined/>}>Selecionar arquivo</Button>
                        </Upload>
                    </Form.Item>
                </>
            )}
        </>
    );
}
